import { store } from '@betacrew/jars-flux';
import { all, delay, put, takeLeading } from "redux-saga/effects";
import { PAGE_STATE } from '../../../constants/constants';
import { componentKey, setLoadingState, setSalesTax, setSalexTaxCalculationSuccessfull, setZipCodeValidationSuccess } from './AddressInformationCardSlice';
import GeneralDataService from '../../../../../services/GeneralDataService';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../../components/toast/constants';
import PaymentDataService from '../../../../../services/PaymentDataService';
import { ADDRESS_INFORMATION_LOADING_STATES } from './constants';

export const { validateZipCode, calculateSalesTax } = {

    validateZipCode: (payload) => {
        return {
            type: "SALES_TAX/VALIDATE_ZIP_CODE",
            payload
        }
    },

    calculateSalesTax: (payload) => {
        return {
            type: "SALES_TAX/CALCULATE",
            payload
        }
    }
}

function* validateZipCodeAsync(action) {
    try {

        yield put(setLoadingState({ state: ADDRESS_INFORMATION_LOADING_STATES.ZIP_VALIDATION_LOADING }))
        const { Country, State, ZIP } = action.payload;

        if (Country?.value !== "US") {
            yield put(setZipCodeValidationSuccess(true));
            yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
            return;
        }

        const data = {
            State: State.value,
            ZipCode: ZIP.value
        }

        const response = yield GeneralDataService.validateZipCode(data);

        if (response?.data?.Status) {
            yield put(setZipCodeValidationSuccess(true));
        } else {
            yield put(setZipCodeValidationSuccess(false));
            yield put(addNotifications({ heading: "Zip code validation failed", message: response?.data?.Message }));
        }
    } catch (error) {
        console.error(error);
        yield put(setZipCodeValidationSuccess(false));
        yield put(addNotifications({ heading: "Failed to validate the zip code", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: ADDRESS_INFORMATION_LOADING_STATES.ZIP_VALIDATION_READY }))
    }
}

function* calculateSalesTaxAsync(action) {
    try {
        yield put(setLoadingState({ state: ADDRESS_INFORMATION_LOADING_STATES.CALCULATE_SALES_TAX_LOADING }))

        const { Address, Country, State, City, ZIP, TotalAmount, UspsMailing, UspsAmount, SavedCardValue, isUsps, isSubscription, SubscriptionAmount } = action.payload;

        const requestPayload = {
            StreetAddress1: Address?.value,
            City: City?.value || "",
            State: State?.value,
            Zipcode: ZIP?.value,
            Country: Country?.value,
            TotalAmount: Number((TotalAmount - UspsAmount).toFixed(2)),
            SavedCardValue: SavedCardValue || "",
            UspsMailing: UspsMailing || 0,
            isUsps: isUsps || false,
            isSubscription: isSubscription || false,
            UspsAmount: UspsAmount || 0,
            SubscriptionAmount: SubscriptionAmount || 0
        }

        const response = yield PaymentDataService.getSalesTaxAmount(requestPayload);

        if (response?.data) {
            const { Status, Message, Data } = response?.data;

            if (Status) {
                yield put(setSalesTax(Data));
                yield put(setSalexTaxCalculationSuccessfull(true));
            } else {
                yield put(setSalexTaxCalculationSuccessfull(false));
                yield put(addNotifications({ heading: "Something went wrong, Failed to calculate the sales tax", message: Message }));
            }
        }

    } catch (error) {
        console.error(error);
        yield put(setSalexTaxCalculationSuccessfull(false));
        yield put(addNotifications({ heading: "Failed to calculate the sales tax", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: ADDRESS_INFORMATION_LOADING_STATES.CALCULATE_SALES_TAX_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLeading(validateZipCode().type, validateZipCodeAsync),
        takeLeading(calculateSalesTax().type, calculateSalesTaxAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);